<template>
  <div>
    <vs-chip
      :color="utilsList.getColorAtivoInativo(value)"
      class="product-order-status"
    >
      {{ utilsList.getAtivoInativo(value) }}
    </vs-chip>
  </div>
</template>

<script>
import utilsList from "./index";

export default {
  data() {
    return {
      utilsList,
    };
  },
  props: ["value"],
};
</script>